module.exports = __webpack_public_path__ + "img/paimai.7c84f9df.png";